<div class="visibility-dialog">
  <h2 mat-dialog-title>
    <mat-icon class="title-icon">visibility</mat-icon>
    Naptár-láthatóság kezelése
  </h2>

  <div mat-dialog-content>
    @if (isLoading) {
      <div class="loading-container">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Betöltés...</p>
      </div>
    }

    @if (!isLoading) {
      <p class="help-text">
        <mat-icon>info</mat-icon>
        Sorok: ki nézi (viewer) — Oszlopok: kinek a naptárát (target)
      </p>

      <!-- Mátrix táblázat -->
      <div class="matrix-scroll">
        <table class="visibility-matrix">
          <thead>
            <tr>
              <th class="name-header">Felhasználó →</th>
              @for (target of users; track target.id) {
                <th class="target-header">
                  <span class="target-name">{{ target.name }}</span>
                </th>
              }
            </tr>
          </thead>
          <tbody>
            @for (viewer of users; track viewer.id) {
              <tr>
                <td class="viewer-cell">
                  <span>{{ viewer.name }}</span>
                </td>
                @for (target of users; track target.id) {
                  <td class="check-cell">
                    @if (viewer.id !== target.id) {
                      <mat-checkbox
                        [checked]="isChecked(viewer.id, target.id)"
                        (change)="toggleVisibility(viewer.id, target.id)"
                        color="primary">
                      </mat-checkbox>
                    } @else {
                      <span class="self-indicator">—</span>
                    }
                  </td>
                }
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>

  <div mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Mégse</button>
    <button
      mat-flat-button
      color="primary"
      (click)="onSave()"
      [disabled]="!hasChanges || isSaving">
      @if (isSaving) {
        <mat-spinner diameter="18" class="save-spinner"></mat-spinner>
      }
      <mat-icon>save</mat-icon>
      Mentés
    </button>
  </div>
</div>
